// 非人物类热点实体：节目/作品、赛事、组织、待归档热点词。
// 这些词不应该被识别成“名人”，但应该参与关联推荐。

export type HotEntityType = "program" | "event" | "organization" | "keyword";

export interface HotEntity {
  name: string;
  aliases: string[];
  type: HotEntityType;
  meta: string;
}

const programs: HotEntity[] = [
  { name: "你好星期六", aliases: ["好六"], type: "program", meta: "综艺节目" },
  { name: "歌手", aliases: ["我是歌手", "歌手2024", "歌手2025", "歌手2026"], type: "program", meta: "音乐综艺" },
  { name: "奔跑吧", aliases: ["跑男"], type: "program", meta: "综艺节目" },
  { name: "快乐大本营", aliases: ["快本"], type: "program", meta: "综艺节目" },
  { name: "极限挑战", aliases: ["极挑"], type: "program", meta: "综艺节目" },
  { name: "王牌对王牌", aliases: [], type: "program", meta: "综艺节目" },
  { name: "密室大逃脱", aliases: ["密逃"], type: "program", meta: "综艺节目" },
  { name: "大侦探", aliases: ["明星大侦探", "明侦"], type: "program", meta: "综艺节目" },
  { name: "乘风破浪的姐姐", aliases: ["浪姐", "乘风"], type: "program", meta: "综艺节目" },
  { name: "披荆斩棘的哥哥", aliases: ["披哥", "披荆斩棘"], type: "program", meta: "综艺节目" },
  { name: "青春有你", aliases: [], type: "program", meta: "选秀节目" },
  { name: "创造营", aliases: ["创造101", "创造2019", "创造2020", "创造2021"], type: "program", meta: "选秀节目" },
  { name: "偶像练习生", aliases: [], type: "program", meta: "选秀节目" },
  { name: "中国好声音", aliases: [], type: "program", meta: "音乐综艺" },
  { name: "中国新说唱", aliases: [], type: "program", meta: "音乐综艺" },
  { name: "乐队的夏天", aliases: ["乐夏"], type: "program", meta: "音乐综艺" },
  { name: "天赐的声音", aliases: [], type: "program", meta: "音乐综艺" },
  { name: "五十公里桃花坞", aliases: ["桃花坞"], type: "program", meta: "综艺节目" },
  { name: "花儿与少年", aliases: ["花少"], type: "program", meta: "综艺节目" },
  { name: "中餐厅", aliases: [], type: "program", meta: "综艺节目" },
  { name: "向往的生活", aliases: [], type: "program", meta: "综艺节目" },
  { name: "令人心动的offer", aliases: ["心动的offer"], type: "program", meta: "综艺节目" },
];

const events: HotEntity[] = [
  { name: "世界杯", aliases: ["FIFA世界杯", "足球世界杯"], type: "event", meta: "体育赛事" },
  { name: "欧洲杯", aliases: ["欧锦赛"], type: "event", meta: "体育赛事" },
  { name: "亚洲杯", aliases: [], type: "event", meta: "体育赛事" },
  { name: "奥运会", aliases: ["奥运", "巴黎奥运", "洛杉矶奥运"], type: "event", meta: "体育赛事" },
  { name: "冬奥会", aliases: ["冬奥"], type: "event", meta: "体育赛事" },
  { name: "亚运会", aliases: ["亚运"], type: "event", meta: "体育赛事" },
  { name: "全运会", aliases: [], type: "event", meta: "体育赛事" },
  { name: "春晚", aliases: ["央视春晚"], type: "event", meta: "大型晚会" },
  { name: "高考", aliases: ["全国高考"], type: "event", meta: "公共事件" },
  { name: "考研", aliases: ["研究生考试"], type: "event", meta: "公共事件" },
];

const organizations: HotEntity[] = [
  { name: "国乒", aliases: ["中国乒乓球队"], type: "organization", meta: "体育组织" },
  { name: "国羽", aliases: ["中国羽毛球队"], type: "organization", meta: "体育组织" },
  { name: "中国女排", aliases: [], type: "organization", meta: "体育组织" },
  { name: "中国男篮", aliases: ["男篮"], type: "organization", meta: "体育组织" },
  { name: "中国女篮", aliases: ["女篮"], type: "organization", meta: "体育组织" },
  { name: "中国男足", aliases: ["国足"], type: "organization", meta: "体育组织" },
  { name: "中国女足", aliases: ["女足"], type: "organization", meta: "体育组织" },
  { name: "央视", aliases: ["中央广播电视总台", "CCTV"], type: "organization", meta: "媒体机构" },
];

const keywords: HotEntity[] = [
  { name: "演唱会", aliases: ["巡演"], type: "keyword", meta: "热点词" },
  { name: "电影票房", aliases: ["票房"], type: "keyword", meta: "热点词" },
  { name: "暑期档", aliases: ["春节档", "国庆档"], type: "keyword", meta: "热点词" },
  { name: "毕业季", aliases: [], type: "keyword", meta: "热点词" },
  { name: "端午", aliases: ["端午节"], type: "keyword", meta: "热点词" },
  { name: "七夕", aliases: ["七夕节"], type: "keyword", meta: "热点词" },
];

export const HOT_ENTITIES: HotEntity[] = [
  ...programs,
  ...events,
  ...organizations,
  ...keywords,
];

export const HOT_ENTITY_MAP: Map<string, HotEntity> = new Map();

HOT_ENTITIES.forEach((entity) => {
  HOT_ENTITY_MAP.set(entity.name, entity);
  entity.aliases.forEach((alias) => HOT_ENTITY_MAP.set(alias, entity));
});

export function getAllHotEntityNames(): string[] {
  const names: string[] = [];
  HOT_ENTITIES.forEach((entity) => {
    names.push(entity.name);
    names.push(...entity.aliases);
  });
  return names;
}

export function extractHotEntitiesFromText(text: string): HotEntity[] {
  const foundEntities = new Set<HotEntity>();
  const sortedNames = getAllHotEntityNames().sort((a, b) => b.length - a.length);

  for (const name of sortedNames) {
    if (text.includes(name)) {
      const entity = HOT_ENTITY_MAP.get(name);
      if (entity) foundEntities.add(entity);
    }
  }

  return Array.from(foundEntities);
}

export function containsHotEntityName(name: string): boolean {
  return HOT_ENTITY_MAP.has(name.trim());
}
